import * as z from "zod";

export const getAmazonAuthUrl = {
  name: "getAmazonAuthUrl" as const,
  input: z.object({ returnTo: z.literal("carriers").optional() }),
  output: z.object({ authUrl: z.string() }),
};
